import dayjs from 'dayjs';
import 'dayjs/locale/de.js';
import 'dayjs/locale/pl.js';
import 'dayjs/locale/sk.js';
import 'dayjs/locale/en-gb.js';
import 'dayjs/locale/en.js';
import dayOfYear from 'dayjs/plugin/dayOfYear.js';
import duration from 'dayjs/plugin/duration.js';
import isBetween from 'dayjs/plugin/isBetween.js';
import isLeapYear from 'dayjs/plugin/isLeapYear.js';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore.js';
import isoWeek from 'dayjs/plugin/isoWeek.js';
import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear.js';
import localeData from 'dayjs/plugin/localeData.js';
import localizedFormatPlugin from 'dayjs/plugin/localizedFormat.js';
import minMax from 'dayjs/plugin/minMax.js';
import quarterOfYear from 'dayjs/plugin/quarterOfYear.js';
import relativeTime from 'dayjs/plugin/relativeTime.js';
import utc from 'dayjs/plugin/utc.js';
import weekOfYear from 'dayjs/plugin/weekOfYear.js';

dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(localizedFormatPlugin);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(quarterOfYear);
dayjs.extend(relativeTime);
dayjs.extend(localeData);
dayjs.extend(isoWeeksInYear);
dayjs.extend(isLeapYear);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(minMax);
dayjs.extend(dayOfYear);

export default dayjs;
